<template>
<div class="top-nav-container" :style="{ marginTop: isIE ? '40px' : 0 }">
  <div class="main-1 clearfix">
    <div class="logo left">
      <img src="~assets/logo.jpg" alt="logo" />
      <span></span>
    </div>
    <div class="page-nav left">
      <nuxt-link v-for="item of navList" :key="item.path" :to="item.path" :exact="item.path === '/'">{{ item.title }}</nuxt-link>
    </div>
     <!-- <div class="search right">
      <input v-model.trim="keyword" @keydown.enter="search" placeholder="输入老师名..." /><i @click="search" class="iconfont icon-ss center"></i>
    </div> -->
  </div>
</div>
</template>

<script>
export default {
  data () {
    return {
      // 杭州专属菜单
      hangzhouNavList: [
        { title: '首页', path: '/' },
        { title: '商务合作', path: '/vertically' },
        { title: '信息咨讯', path: '/news' },
        { title: '招贤纳士', path: '/join' },
        { title: '我的', path: '/user' },
        { title: '关于', path: '/about' },
      ],
      // 默认菜单
      defaultNavList: [
        { title: '首页', path: '/' },
        { title: '互动', path: '/room' },
        { title: '问答', path: '/question' },
        { title: '文章', path: '/article' },
        { title: '我的', path: '/user' },
        { title: '关于', path: '/about' },
      ],
      navList: [],
      keyword: '',
      unread: '',
      isIE: false
    }
  },
  mounted () {
    this.isIE = /Trident/.test(navigator.userAgent)
    this.initNavMenu()
  },
  methods: {
    // 获取当前城市（支持跨域）
    async getCurrentCity() {
      // 优先从缓存读取
      const cachedCity = localStorage.getItem('user_city')
      const cacheTime = localStorage.getItem('user_city_time')
      
      if (cachedCity && cacheTime && (Date.now() - cacheTime < 30 * 60 * 1000)) {
        // console.log('使用缓存城市：', cachedCity)
        return cachedCity
      }
      
      // 多个备用 API（都支持跨域）
      const apis = [
        'https://api.ip.sb/geoip',           // 支持跨域，返回数据完整
        'https://ipinfo.io/json',             // 支持跨域
        'https://api.myip.com',               // 简单好用
        'https://ip-api.com/json/',           // 免费无需key
      ]
      
      for (let api of apis) {
        try {
          console.log('尝试API：', api)
          const response = await fetch(api, {
            mode: 'cors',  // 明确使用CORS
            cache: 'no-cache'
          })
          
          if (!response.ok) throw new Error(`HTTP ${response.status}`)
          
          const data = await response.json()
          console.log('API返回数据：', data)
          
          let city = null
          
          // 根据不同API格式提取城市
          if (data.city) {
            city = data.city
          } else if (data.region) {
            city = data.region
          } else if (data.country && data.region) {
            city = data.region
          }
          
          // 如果有城市信息，缓存并返回
          if (city) {
            // 标准化城市名称
            if (city === 'Hangzhou' || city === 'hangzhou') city = '杭州'
            
            localStorage.setItem('user_city', city)
            localStorage.setItem('user_city_time', Date.now())
            // console.log('获取到城市：', city)
            return city
          }
        } catch (error) {
          console.warn(`API ${api} 失败:`, error.message)
          continue  // 尝试下一个API
        }
      }
      
      // 所有API都失败，返回默认值
      console.warn('所有API都失败，使用默认值')
      return null
    },
    
    async initNavMenu() {
      // 显示加载中的菜单（可选）
      this.navList = this.defaultNavList
      
      const city = await this.getCurrentCity()
      // console.log('最终城市：', city)
      
      // 判断是否为杭州
      if (city && (city === '杭州' || city === '杭州市' || city.toLowerCase().includes('hangzhou'))) {
        this.navList = this.hangzhouNavList
        // console.log('✅ 杭州用户，显示定制菜单')
      } else {
        this.navList = this.defaultNavList
        // console.log('✅ 非杭州用户，显示默认菜单')
      }
    },
    
    search () {
      if (this.keyword !== '') {
        this.$router.push({ path: '/search', query: { keyword: this.keyword } })
        this.keyword = ''
      }
    }
  }
}
</script>

<style lang="less">
.top-nav-container {
  background: #e43a3d;
  .logo {
    img {
      width: 120px; height: 43px; display: inline-block; margin: 24px 100px 0 0;
    }
  }
  .page-nav {
    overflow: hidden;
    a {
      float: left; line-height: 90px; width: 80px; font-size: 16px; color: #fff; text-align: center;
      &:hover:not(.nuxt-link-active) { background: rgba(198, 20, 32, .4); }
      &.nuxt-link-active { background: #C61420; font-weight: bold; }
    }
  }
}
</style>